<form [formGroup]="activityForm">
  <ng-container *ngIf="activity">
    <div class="activityWrapper ">
      <div *ngFor="let question of activity.questionList; index as i">
        <ng-container *ngIf="question.status !== 'delete' ">
          <div class="source_box">
            <div class="source-qus-wrap">
            <app-question [pillarName]="pillarName" [question]="question" [questionForm]="activityForm.get('questionList')['controls'][i]" [index]="i" [activity]="activity"
              (questionFormValid)="errorInActivityComponent($event)"></app-question>
            </div>
            
            <div class="gigaton-warning" *ngIf="activity && (activity.thresholdSL && question['subTotalReportSL'] > activity.thresholdSL) ||
              (activity.thresholdSO && question['subTotalReportSO'] > activity.thresholdSO) || (activity.threshold && question['subTotalReport'] > activity.threshold)">
             {{'PG_QUESTION_THRESHOLD' | translate}}</div>
              <div class="auto-calc-wrap m-top-8">
                <div class="auto-calcFeild " *ngIf="question['subTotalReport']">
                  <mat-label> {{'SubtotalLabel' | translate}}</mat-label>
                  <mat-form-field  appearance="outline" class="totalInput">
                      <input disabled="true" matInput  value="{{question['subTotalReport'] | number:'1.1-1'}}" [matTooltip]="question['subTotalReport'] | number:'1.1-1'" matTooltipPosition="above" placeholder="0.00" />
                      <span class="calculateFeild-unit" matSuffix>mt</span>
                  </mat-form-field>
              </div>
              <div class="auto-calcFeild " *ngIf="question['subTotalReportSL'] ">
                <mat-label> {{'GIGATON.SUBTOTALLABEL.SL' | translate}}</mat-label>
                <mat-form-field  appearance="outline" class="totalInput">
                    <input disabled="true" matInput value="{{question['subTotalReportSL'] | number:'1.1-1'}}" [matTooltip]="question['subTotalReportSL'] | number:'1.1-1'" matTooltipPosition="above" placeholder="0.00" />
                    <span class="calculateFeild-unit" matSuffix>{{'GIGATON_CALCULATOR_LAND_UNIT' | translate}}</span>
                </mat-form-field>
            </div>
            <div class="auto-calcFeild " *ngIf="question['subTotalReportSO'] ">
                <mat-label> {{'GIGATON.SUBTOTALLABEL.SO' | translate}}</mat-label>
                <mat-form-field appearance="outline" class="totalInput">
                    <input disabled="true" matInput value="{{question['subTotalReportSO'] | number:'1.1-1'}}" [matTooltip]="question['subTotalReportSO'] | number:'1.1-1'" matTooltipPosition="above" placeholder="0.00" />
                    <span class="calculateFeild-unit" matSuffix>{{'GIGATON_CALCULATOR_OCEAN_UNIT' | translate}}</span>
                </mat-form-field>
            </div>
            </div>
            <div class="gigaton-info" *ngIf="checkResultNoResult(question)">
              {{'PG_QUESTION_NO_RESULT' | translate}}</div>

          </div>



          <ng-container class="" *ngIf=" activity.multipleEntries && (i != 0)">

            <em class="material-icons remove_icon_clas" (click)="remove(i)">highlight_off</em>
          </ng-container>
        </ng-container>


      </div>

      <div class="activityiconContainer ">
        <ng-container *ngIf="activityForm.touched || chinaControl.touched">
          {{setActivityStatus('modified')}}
        </ng-container>
        <ng-container *ngIf="activity.multipleEntries">

          <div (click)="addCalculator()">
            <em class="material-icons add_icon">add_circle_outline</em>

            <span class="addmoretxt">{{'AddMoreCalc'| translate}} </span>

          </div>

        </ng-container>

      </div>
      <div style="clear: both;"></div>

    </div>
    <span class="negetive-error" *ngIf="!activity.noCalculation && !activity.hasNoGHGemission && !activity.acceptZero &&
        activity['totalReport'] <=  0 && activity['totalReportSL'] <=  0 && activity['totalReportSO'] <=  0"> {{'CalculatedValueNegative' |
            translate}}</span>
    <div class="calculatebtnContainer">



    </div>

        <div class="submitbtnContainer " *ngIf="activity && !activity.noCalculation">
      <button type="submit" (click)="onSubmit()">{{'CalculateBTN' | translate}}</button>

      <div class="auto-calc-wrap">
        <div class="auto-calcFeild" *ngIf="activity['totalReport']">

              <mat-label> {{'GrandTotalLabel' | translate}}</mat-label>
              <mat-form-field appearance="outline" class="totalInput">
                  <input disabled="true" matInput value="{{activity['totalReport'] | number:'1.1-1'}}" matTooltip="{{activity['totalReport'] | number:'1.1-1'}}" matTooltipPosition="above" placeholder="0.00" />
                  <span class="calculateFeild-unit" matSuffix>mt</span>
              </mat-form-field>

        </div>
        <div class="auto-calcFeild" *ngIf="activity['totalReportSL']">

              <mat-label class=""> {{'GIGATON.GRANDTOTALLABEL.SL' | translate}}</mat-label>
              <mat-form-field appearance="outline" class="totalInput">
                  <input disabled="true" matInput value="{{activity['totalReportSL'] | number:'1.1-1'}}" [matTooltip]="activity['totalReportSL'] | number:'1.1-1'" matTooltipPosition="above" placeholder="0.00" />
                  <span class="calculateFeild-unit" matSuffix>{{'GIGATON_CALCULATOR_LAND_UNIT' | translate}}</span>
              </mat-form-field>

        </div>
        <div class="auto-calcFeild" *ngIf="activity['totalReportSO']">

            <mat-label class=""> {{'GIGATON.GRANDTOTALLABEL.SO' | translate}}</mat-label>
            <mat-form-field appearance="outline" class="totalInput">
                <input disabled="true" matInput value="{{activity['totalReportSO'] | number:'1.1-1'}}" [matTooltip]="activity['totalReportSO'] | number:'1.1-1'" matTooltipPosition="above" placeholder="0.00" />
                <span class="calculateFeild-unit" matSuffix>{{'GIGATON_CALCULATOR_OCEAN_UNIT' | translate}}</span>
            </mat-form-field>

      </div>
      </div>

        </div>


    
  </ng-container>
  <div *ngIf="imgHelpDialog" class="imgOverlay">
    <div class="img-modal">
        <div class="modal-close-btn">
            <img class="close-btn" src="assets/images/dialog-close.png" (click)="closeImageModal()" alt="Close Button">
          </div>
      <img class="help-img" [src]='activity.imagePath' alt="Help Image">

    </div>
  </div>

  <div *ngIf="chainaHelpDialog" class="dialog-box">
      <div class="chaina-content">

        <div class="middle-china-text">
          <span [innerHTML]="'ChainaHelpMsg' | translate"></span>
          <br>
          <div class="window-close-btn">
              <button type="button" (click)="closeChinaHelpDialog()" class="close-dialog"> {{'Close' | translate}}</button>
            </div>
        </div>
      </div>
    </div>


</form>
